// src/components/Report/shared/PeriodTabs.jsx
import React from "react";

export const PERIODS = [
  { val: "all", label: "All time" },
  { val: "today", label: "Today" },
  { val: "yesterday", label: "Yesterday" },
  { val: "week", label: "7 days" },
  { val: "month", label: "30 days" },
  { val: "range", label: "Custom" },
];

export default function PeriodTabs({ mode, onChange, periods = PERIODS }) {
  return (
    <div className="dlg-period-tabs">
      {periods.map(({ val, label }) => (
        <button
          key={val}
          onClick={() => onChange(val)}
          className={`dlg-period-tab dlg-period-tab--${mode === val ? "active" : "inactive"}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}